import * as z from 'zod';

// Esses são os parâmetros que o legado usava. Lá `page` começa em 1.
export const legacySearchSchema = z.object({
  page: z.number().optional(),
  q: z.string().optional(),
  tr: z.number().optional(),
});

export const searchSchema = z
  .object({
    pagina: z.number().min(1).optional().catch(undefined),
    filtro: z.string().optional(),
    relatorioId: z.number().optional(),
  })
  .extend(legacySearchSchema.shape)
  .transform(search => ({
    pagina:
      search.pagina ??
      (search.page === undefined ? undefined : Math.max(search.page, 1)),
    filtro: search.filtro ?? search.q,
    relatorioId: search.relatorioId ?? search.tr,
  }));
